import { WrappedFieldProps } from 'redux-form';

import {
  AnnouncementPicker,
  Props as AnnouncementPickerProps,
} from './announcementPicker';

type Props = WrappedFieldProps & AnnouncementPickerProps;

export function FieldAnnouncementPicker({
  fieldProps,
  input: { onChange, value },
  onSelect,
  meta,
  ...announcementPickerProps
}: Props): JSX.Element {
  return (
    <AnnouncementPicker
      {...announcementPickerProps}
      fieldProps={{ meta, ...fieldProps }}
      onSelect={onChange}
      selectedAudio={value}
    />
  );
}
